import { SessionStorageAdapter } from "infra/session-storage";

export const makeSessionStorageAdapter = () => new SessionStorageAdapter();